const API_URL = process.env.REACT_APP_BASEURL

const RD_SURVEYS = {
    REQUEST: "RD_SURVEYS_REQUEST",
    SUCCESS: "RD_SURVEYS_SUCCESS",
    ERROR: "RD_SURVEYS_ERROR"
}

export {
    API_URL,
    RD_SURVEYS
}
